export function evidenceResult(response, data) {
  if (response.status === 503 && data?.code === "EVIDENCE_ACCEPTANCE_REQUIRED") {
    return { error: "Kaynakların doğrulanması sürüyor. Kaynaklı cevap hizmeti henüz hazır değil.", heading: "Kaynaklı cevap hazırlanıyor" };
  }
  if (!response.ok) {
    return { error: "Hizmete şu anda ulaşılamıyor. Lütfen daha sonra tekrar deneyin.", heading: "İstek tamamlanamadı" };
  }
  if (!Array.isArray(data?.evidence) || !data.evidence.length ||
      typeof data.answer !== "string" || !data.answer.trim() ||
      data.evidence.some((item) => !item || typeof item !== "object")) {
    return { error: "Bu soru için doğrulanabilir kaynak sunulamadı.", heading: "Kanıt bulunamadı — cevap üretilmedi." };
  }
  return data;
}
